export class TrixContentAttachmentPreviewHelperService {
  constructor(trixContentContainerElement) {
    this.element = trixContentContainerElement;
  }

  addAttachmentClickEventHandler(callback) {
    const handleClick = event => {
      const attachment = event.target.closest("action-text-attachment");
      if (!attachment) {
        return;
      }
      const attachmentAttributes = this.parseAttachmentAttributes(attachment);
      if (this.isPreviewableAttachment(attachmentAttributes)) {
        const attachments = this.getSimilarAttachments(attachmentAttributes);
        const currentIndex = attachments.findIndex(
          att => att.sgid === attachmentAttributes.sgid,
        );
        callback({ attachments, currentIndex });
      }
    };

    this.element.addEventListener("click", handleClick);

    return () => this.element.removeEventListener("click", handleClick);
  }

  getSimilarAttachments(attachment) {
    const filterFunc =
      (this.isImageAttachment(attachment) && this.isImageAttachment) ||
      (this.isPdfAttachment(attachment) && this.isPdfAttachment);
    return [...this.element.querySelectorAll("action-text-attachment")]
      .map(this.parseAttachmentAttributes)
      .filter(filterFunc);
  }

  isPreviewableAttachment(attachment) {
    return Boolean(
      attachment.url &&
      (this.isPdfAttachment(attachment) || this.isImageAttachment(attachment)),
    );
  }

  isImageAttachment({ content_type }) {
    return ["image/png", "image/jpeg", "image/jpg", "image/gif"].includes(
      content_type,
    );
  }

  isPdfAttachment({ content_type }) {
    return ["application/pdf"].includes(content_type);
  }

  parseAttachmentAttributes(attachment) {
    return {
      sgid: attachment.getAttribute("sgid"),
      content_type: attachment.getAttribute("content-type"),
      url:
        attachment.querySelector("[data-target~='blob-container']")?.dataset
          ?.blobUrl || "",
      filename: attachment.getAttribute("filename") || "",
      filesize: attachment.getAttribute("filesize"),
      width: attachment.getAttribute("width"),
      height: attachment.getAttribute("height"),
    };
  }
}
